export const SUBMIT_MEMBER_OTP_LOADING = "SUBMIT_REGISTER_OTP_LOADING"
export const UPDATE_MEMBER_OTP_FORM = "UPDATE_REGISTER_OTP_FORM"
export const UPDATE_MEMBER_OTP_DATA_FORM = "UPDATE_MEMBER_OTP_DATA_FORM"